export default "__VITE_ASSET__teWKn_nC__"